import RelatedRequest from './RelatedRequest';

export default RelatedRequest;
